/**
 * @generated SignedSource<<e202bb41615ca6cb271fb3b9c04bb187>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type attachmentItems_AtlassianSearchPage_DropdownItems$data = {
  readonly attachments: ReadonlyArray<{
    readonly fileType: string | null;
    readonly title: string | null;
    readonly url: string | null;
  }> | null;
  readonly entity: {
    readonly attachments?: ReadonlyArray<{
      readonly mimeType: string | null;
      readonly thumbnailUrl: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
  readonly lastModifiedDate: string | null;
  readonly " $fragmentType": "attachmentItems_AtlassianSearchPage_DropdownItems";
};
export type attachmentItems_AtlassianSearchPage_DropdownItems$key = {
  readonly " $data"?: attachmentItems_AtlassianSearchPage_DropdownItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"attachmentItems_AtlassianSearchPage_DropdownItems">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "title"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "attachmentItems_AtlassianSearchPage_DropdownItems",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "SearchResultGraphAttachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "fileType"
        },
        (v1/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalAttachment",
              "kind": "LinkedField",
              "name": "attachments",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "mimeType"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "thumbnailUrl"
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "b50007094eba88dbf814e17330590a16";

export default node;
